import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { useMemo, useState } from "react";
import { darkTheme } from "./utils/Themes";
import Navbar from "./components/Navbar";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import Contact from "./components/Contact";
import TacticalCursor from "./components/TacticalCursor";
import SystemHUD from "./components/SystemHUD";
import GlitchIntro from "./components/GlitchIntro";
import getMuiTheme from "./themes/muiTheme";
import { ThemeProvider as MuiThemeProvider, CssBaseline, Box } from "@mui/material";

function App() {
  const [openModal, setOpenModal] = useState({ state: false, project: null });
  const muiTheme = useMemo(() => getMuiTheme(darkTheme), []);

  return (
    <StyledThemeProvider theme={darkTheme}>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        <Router>
          <GlitchIntro />
          <TacticalCursor />
          <SystemHUD />
          {/* Static noise overlay for pure tactical feel */}
          <div className="noise-overlay" />
          
          <Box sx={{ minHeight: "100vh", position: "relative", zIndex: 2, pb: 10 }}>
            <HeroSection />
            <Skills />
            <Experience />
            <Projects setOpenModal={setOpenModal} />
            <Education />
            <Contact />
            <Footer />
            <Navbar />
            {openModal.state && <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />}
          </Box>
        </Router>
      </MuiThemeProvider>
    </StyledThemeProvider>
  );
}

export default App;
